import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ERadioColors = {
	red: 'red',
	amber: 'amber',
	green: 'green',
	orange: 'orange',
} as const;

export type TRadioColors = TValueOfStringRecord<typeof ERadioColors>
